module.exports = __webpack_public_path__ + "img/team.7b8e3547.png";